
import React from 'react';
import FormInput from '../FormInput';
import SelectInput from '../SelectInput';
import { CoreIssueDetails } from '../../types';

interface CoreIssueDetailsFormProps {
  data: CoreIssueDetails;
  onChange: (field: string, value: string) => void;
  errors: Record<string, string>;
}

const CoreIssueDetailsForm: React.FC<CoreIssueDetailsFormProps> = ({
  data,
  onChange,
  errors
}) => {
  return (
    <div className="animate-fade-in">
      <h3 className="text-lg font-medium mb-4">Core Campaign Details</h3>
      
      <FormInput
        id="campaign_name"
        label="Campaign Name"
        value={data.campaign_name}
        onChange={(e) => onChange('campaign_name', e.target.value)}
        required
        error={errors['core_issue_details.campaign_name']}
      />
      
      <SelectInput
        id="campaign_type"
        label="Campaign Type"
        options={['Industrial Outcome', 'Legislative/Regulatory', 'Electoral']}
        value={data.campaign_type}
        onChange={(e) => onChange('campaign_type', e.target.value)}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SelectInput
          id="current_status"
          label="Current Campaign Status"
          options={['Planning', 'Active', 'Stalled', 'Escalating', 'Resolved', 'Other']}
          value={data.current_status}
          onChange={(e) => onChange('current_status', e.target.value)}
        />
        
        <FormInput
          id="start_date"
          label="Campaign Start Date (if applicable)"
          type="date"
          value={data.start_date || ''}
          onChange={(e) => onChange('start_date', e.target.value)}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormInput
          id="target_entity"
          label="Target Entity"
          placeholder="Government department, politician, electoral district"
          value={data.target_entity}
          onChange={(e) => onChange('target_entity', e.target.value)}
          required
          error={errors['core_issue_details.target_entity']}
        />
        
        <FormInput
          id="campaign_timeline"
          label="Campaign Timeline"
          placeholder="e.g., 6 months, election cycle, legislative session"
          value={data.campaign_timeline}
          onChange={(e) => onChange('campaign_timeline', e.target.value)}
        />
      </div>
      
      <FormInput
        id="political_issue"
        label="Key Political Issue"
        placeholder="e.g., healthcare funding, labor rights legislation, electoral reform"
        value={data.political_issue}
        onChange={(e) => onChange('political_issue', e.target.value)}
        required
        error={errors['core_issue_details.political_issue']}
      />
      
      <FormInput
        id="issue_description"
        label="Brief Description of the Issue and Campaign Goals"
        placeholder="Provide 1-3 paragraphs describing the political issue and campaign objectives"
        value={data.issue_description}
        onChange={(e) => onChange('issue_description', e.target.value)}
        multiline
        rows={5}
        required
        error={errors['core_issue_details.issue_description']}
      />
    </div>
  );
};

export default CoreIssueDetailsForm;
